import React, { Component } from "react";
import kr from "locale/kr";
import en from "locale/en";
import cn from "locale/cn";
import jp from "locale/jp";

const withLocale = Basecomponent => {
  return class WithLocale extends Component {
    state = {
      langs: { kr, en, cn, jp }
    };

    setLocale = () => {
      const { langs } = this.state;
      const locale = localStorage.getItem("ctcrLocale");

      let language;

      switch (locale) {
        case "kr":
          language = langs.kr;
          break;
        case "en":
          language = langs.en;
          break;
        case "cn":
          language = langs.cn;
          break;
        case "jp":
          language = langs.jp;
          break;
        default:
          return langs.kr;
      }

      return language;
    };

    componentDidMount() {
      let params = this.props.match.params.locale;

      // params값이 없는 경우 default 는 kr
      if (!params) {
        params = "kr";
      }

      // 언어 설정
      this.props.setValue(params);
    }

    componentDidUpdate(prevProps, prevState) {
      const { location, match } = this.props;

      const locale = localStorage.getItem("ctcrLocale");
      let params = match.params.locale;

      // params값이 없는 경우 default 는 kr
      if (!params) {
        params = "kr";
      }

      // 메인 페이지에서 언어변경된 메인페이지로 들어올 때 언어 재설정
      if (
        prevProps.location.pathname !== location.pathname &&
        params !== locale
      ) {
        this.props.setValue(params);
      }
    }

    render() {
      const language = this.setLocale();
      return <Basecomponent {...this.props} lang={language} />;
    }
  };
};

export default withLocale;
